export type MentorshipStatusValues =
  | 'MENTOR_ACCEPTING'
  | 'WAITING_MENTOR'
  | 'WAITING_MENTEE'
  | 'REFUSED_MENTOR'
  | 'REFUSED_MENTEE'
  | 'FIRST_INTERVIEW'
  | 'LATE_MENTEE_FIRST_INTERVIEW'
  | 'LATE_MENTOR_FIRST_INTERVIEW'
  | 'ONGOING'
  | 'LATE_MENTOR'
  | 'LATE_MENTEE'
  | 'INTERRUPTION_REQUEST_MENTEE'
  | 'INTERRUPTION_REQUEST_MENTOR'
  | 'INTERRUPTED_ADMIN'
  | 'FINISHED_ADMIN'
  | 'FINISHED_DATE';

export const mentorActionRequiredStatus: MentorshipStatusValues[] = [
  'MENTOR_ACCEPTING',
  'WAITING_MENTOR',
  'LATE_MENTOR_FIRST_INTERVIEW',
  'LATE_MENTOR',
];

export const mentorshipStatusCanCreateInterview: MentorshipStatusValues[] = [
  'FIRST_INTERVIEW',
  'WAITING_MENTOR',
  'WAITING_MENTEE',
  'LATE_MENTEE_FIRST_INTERVIEW',
  'LATE_MENTOR_FIRST_INTERVIEW',
  'LATE_MENTEE',
  'LATE_MENTOR',
  'ONGOING',
  'FINISHED_DATE',
];

export enum MENTORSHIP_MENTOR_STATUS {
  MENTOR_ACCEPTING = 'En attente de votre réponse',

  WAITING_MENTOR = "En attente d'une date de rendez-vous",
  WAITING_MENTEE = 'En attente de réponse du mentoré',

  REFUSED_MENTOR = 'Vous avez refusé le mentorat',
  REFUSED_MENTEE = 'Mentorat refusé par le mentoré',

  FIRST_INTERVIEW = 'En attente du premier entretien',

  LATE_MENTOR_FIRST_INTERVIEW = 'Mentorat en retard',
  LATE_MENTEE_FIRST_INTERVIEW = 'Mentorat en retard',

  ONGOING = 'Mentorat en cours',

  LATE_MENTOR = 'Mentorat en retard',
  LATE_MENTEE = 'Mentorat en retard',

  INTERRUPTION_REQUEST_MENTEE = 'Mentorat en cours',
  INTERRUPTION_REQUEST_MENTOR = "Vous avez demandé l'interruption du mentorat",

  INTERRUPTED_ADMIN = 'Mentorat interrompu',

  FINISHED_ADMIN = 'Arrêt du mentorat',
  FINISHED_DATE = 'Mentorat finalisé',
}
export enum MENTORSHIP_MENTEE_STATUS {
  MENTOR_ACCEPTING = "En attente d'acceptation du mentor",

  WAITING_MENTEE = 'En attente de votre réponse',
  WAITING_MENTOR = 'En attente de réponse du mentor',

  REFUSED_MENTEE = 'Vous avez refusé le mentorat',
  REFUSED_MENTOR = 'Mentorat refusé par le mentor',

  FIRST_INTERVIEW = 'En attente du premier entretien',

  LATE_MENTEE_FIRST_INTERVIEW = 'Mentorat en retard',
  LATE_MENTOR_FIRST_INTERVIEW = 'Mentorat en retard',

  ONGOING = 'Mentorat en cours',

  LATE_MENTEE = 'Mentorat en retard',
  LATE_MENTOR = 'Mentorat en retard',

  INTERRUPTION_REQUEST_MENTOR = 'Mentorat en cours',
  INTERRUPTION_REQUEST_MENTEE = "Vous avez demandé l'interruption du mentorat",

  INTERRUPTED_ADMIN = 'Mentorat interrompu',

  FINISHED_ADMIN = 'Arrêt du mentorat',
  FINISHED_DATE = 'Mentorat finalisé',
}

enum MENTORSHIP_STATUS {
  MENTOR_ACCEPTING = "En attente d'acceptation du mentor",

  WAITING_MENTOR = 'En attente de réponse du mentor',
  WAITING_MENTEE = 'En attente de réponse du mentoré',

  REFUSED_MENTOR = 'Mentorat refusé par le mentor',
  REFUSED_MENTEE = 'Mentorat refusé par le mentoré',

  FIRST_INTERVIEW = 'En attente du premier entretien',

  LATE_MENTEE_FIRST_INTERVIEW = 'Premier entretien en retard dû au mentoré',
  LATE_MENTOR_FIRST_INTERVIEW = 'Premier entretien en retard dû au mentor',

  ONGOING = 'En cours de mentorat',

  LATE_MENTOR = 'Mentorat en retard dû au mentor',
  LATE_MENTEE = 'Mentorat en retard dû au mentoré',

  INTERRUPTION_REQUEST_MENTEE = "Demande d'interruption par le mentoré",
  INTERRUPTION_REQUEST_MENTOR = "Demande d'interruption par le mentor",

  INTERRUPTED_ADMIN = 'Mentorat interrompu',

  FINISHED_ADMIN = 'Arrêt du mentorat',
  FINISHED_DATE = 'Mentorat finalisé',
}
export default MENTORSHIP_STATUS;
